import * as Actions from "./actions";
import $ from "jquery";
import ApiService from "../../../../utils/apiService";
import * as Path from './apiRoutes';
import {FILE_CSV, ORDER_CSV, ORDER_XLS, FILE_DATE_FORMAT, ORDER_TABLE, EMPTY_COUNT } from '../../../../utils/constants';
import { isNullOrEmpty } from "../../../../utils/common";
import { ROOT_URL } from "../../../../routes/constants";


const fetchDefault = (pageSize, pageNum, filter) => (dispatch) => {
    
    dispatch(Actions.changeRowSize(pageSize));
    dispatch(Actions.setPage(pageNum,`${ROOT_URL}/Order`));
    let order = {
        businessPartnerCode: filter.businessPartnerCode,
        closingDateTimeFrom: filter.filterStartDate,
        closingDateTimeTo: filter.filterEndDate,
        proposalId: filter.proposalId,
        deadline: filter.processing,
    };
    dispatch(Actions.filter({
                page: pageNum
                ,filterStartDate : filter.filterStartDate
                , filterEndDate: filter.filterEndDate
                , proposalId: filter.proposalId
                , processing: filter.processing
                , proposalName: filter.proposalName}));
    ApiService.post(Path.BP_ORDER_GET_LIST+"/"+pageSize+"/"+pageNum, order)
        .then((response) => {          
            $("."+ORDER_TABLE).scrollTop(EMPTY_COUNT);
            dispatch(Actions.allProposal([]));
            dispatch(Actions.setList(response.data.data));            
        }).catch(()=>{
            dispatch(Actions.setList([])); 
        })
};

const fetchProposal = (obj) => (dispatch) => {

    let empty = false

    if (isNullOrEmpty(obj.proposalId) && isNullOrEmpty(obj.proposalName)) {
        empty = true
    }

    ApiService.post(Path.BP_ORDER_SEARCH_PROPOSAL, obj)
        .then((response) => {
            if (empty) {
                dispatch(Actions.allProposal(response.data.data));
            } else {
                dispatch(Actions.setProposal(response.data.data));
            }
        })

};

const downloadFile = (param) => () => {

    let params = new URLSearchParams();

    Object.keys(param).map((key) =>
        params.append(key, param[key])
    );

    return ApiService.post(Path.BP_ORDER_DOWNLOAD, params, true)
        .then((response) => {
            let moment = require("moment");
            let fileDownload = require('react-file-download');
            let fileName = ((FILE_CSV === param.fileType) ? ORDER_CSV : ORDER_XLS) + moment().format(FILE_DATE_FORMAT)
            fileDownload(response.data, fileName + '.' + param.fileType);
        })
};

export {
    fetchDefault,
    fetchProposal,
    downloadFile,
};
